import { TranslationMap } from '@trimble-gcs/i18n-types';

export function clarityFileBrowserTableTranslations() {
  return {
    columnHeaders: {
      name: {
        text: $localize`:@@import.dialog.picker.clarity.columnHeaders.name:Name`,
        desc: 'Column header for the file name column.',
      },
      size: {
        text: $localize`:@@import.dialog.picker.clarity.columnHeaders.size:Size`,
        desc: 'Column header for the file size column.',
      },
    },
  } satisfies TranslationMap;
}
